import React from 'react';
import styled from 'styled-components';
import AnschlussDescBubble from '../components/AnschlussDescBubble';
import { Container } from '../theme/Grid';
import Ergebnisse from '../components/Ergebnisse';
import LogoImg from '../../assets/img/geberit-logo.svg';
import mediaQ from '../theme/responsive.js';
import Wandsystem from '../components/Wandsystem';
import Wasseranschluesse from '../components/Wasseranschluesse';
import * as Selectors from '../store/selectors';
import { connect } from 'react-redux';
import { FormattedHTMLMessage } from 'react-intl';
import * as Store from '../store/constants';
import GridRow from '../components/GridRow';
import Hauptgrafik from '../components/Infotemplates/Hauptgrafik';
import PropTypes from 'prop-types';
import InfoBox from '../components/InfoBox';
import { ButtonDisabled, ButtonPrimary } from '../theme/Buttons';
import data from '../data/data';
import Footer from '../components/Footer';
import PrismicServive from '../cms/PrismicService';

class MainScreen extends React.Component {
    mounted = false;

    constructor(props) {
        super(props);
        this.state = { headerData: {}, footerData: {} };
    }

    resetPage() {
        location.reload();
    }

    async getPrismicData() {
        const prismicService = PrismicServive();
        const prismicData = await prismicService.getLayout('et-EE');
        if (this.mounted) {
            this.setState({
                headerData: prismicData.headerData,
                footerData: prismicData.footerData,
            });
        }
    }

    componentDidMount() {
        this.mounted = true;
        window.addEventListener('load', this.cacheImages);
        this.getPrismicData();
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    async cacheImages() {
        const { locale } = document.getElementById('root').dataset;
        let states = [
            './assets/img/placeholder.jpg',
            './assets/img/schallpegelinfo_' + locale + '.jpg',
            './assets/img/geraeuscheinfo_' + locale + '.jpg',
            './assets/img/seite55_' + locale + '.jpg',
            './assets/img/save.png',
            './assets/img/knowhowinstalled.jpg',
        ];
        data.forEach(el => {
            if (el.filenameWithoutExtension && !states.includes(el.filenameWithoutExtension)) {
                states = [...states, './assets/img/reports/jpg/' + el.filenameWithoutExtension + '.jpg'];
                states = [...states, './assets/img/reports/printview/' + el.filenameWithoutExtension + '.jpg'];
            }
        });
        const promises = states.map(src => {
            return new Promise((resolve, reject) =>
                setTimeout(() => {
                    const img = new Image();
                    img.src = src;
                    img.onload = resolve();
                    img.onerror = reject();
                }, 0)
            );
        });
        await Promise.all(promises);
    }

    render() {
        // console.log(this.props);
        const {
            result,
            translationsAvalible,
            korrekturWerte,
            abwasserFallleitung,
            abwasserAnschlussleitung,
            abwasserFallleitungActive,
            abwasserAnschlussleitungActive,
        } = this.props;

        if (!translationsAvalible) {
            return (
                <div>
                    <span>Loading ...</span>
                </div>
            );
        }

        return (
            <React.Fragment>
                <Maincontainer>
                    <SelectionComponents>
                        <HeaderFixed>
                            <HeaderContainer>
                                <HeadingLogoWrapper>
                                    <HeadingLogo>
                                        <img src={this.state.headerData.logoUrl} />
                                    </HeadingLogo>
                                    <HeadingRegion>
                                        <span>{this.state.headerData.countryCode}</span>
                                    </HeadingRegion>
                                </HeadingLogoWrapper>
                            </HeaderContainer>
                        </HeaderFixed>
                    </SelectionComponents>
                </Maincontainer>

                <Header>
                    <HeadingWrapper>
                        <HeadingLogo>
                            <img src={LogoImg} />
                        </HeadingLogo>
                        <HeadingText>
                            <FormattedHTMLMessage id="title" />
                            <br />
                        </HeadingText>
                        <SubHeadingText>
                            <FormattedHTMLMessage id="title-subline" />
                        </SubHeadingText>
                    </HeadingWrapper>
                </Header>
                <Maincontainer
                    ref={node => {
                        this.main = node;
                    }}>
                    <SelectionComponents>
                        <Wandsystem heading={<FormattedHTMLMessage id="wand-system-heading" />} />
                        <Wasseranschluesse heading={<FormattedHTMLMessage id="wasser-anschluesse-heading" />} />
                    </SelectionComponents>

                    <Schallschutz>
                        {result !== null ? (
                            <>
                                <SchallschutzImgWrapper>
                                    <img
                                        src={`./assets/img/reports/jpg/${result.filenameWithoutExtension}.jpg`}
                                        data-nodeid={result.id}
                                        alt={result.wandAufbau}
                                    />
                                    {Object.keys(Store.XML_BUBBLE_POSITIONS).map(key => {
                                        const { posX, posY } = Store.XML_BUBBLE_POSITIONS[key];

                                        return <AnschlussDescBubble key={key} posX={posX} posY={posY} toolTipText={result.bubbleDescriptions[key]} />;
                                    })}
                                </SchallschutzImgWrapper>
                                <div>
                                    <BildbeschreibungHeading>
                                        {result.imageTitle}
                                        <InfoBox positioning="right" content={<Hauptgrafik />} />
                                    </BildbeschreibungHeading>
                                </div>
                            </>
                        ) : (
                            <>
                                <SchallschutzImgWrapper>
                                    <img src={`./assets/img/placeholder.jpg`} />
                                </SchallschutzImgWrapper>
                                <div>
                                    <BildbeschreibungHeading>Kahjuks teie valikule ei ole hetkel eelvaadet saadaval</BildbeschreibungHeading>
                                </div>
                            </>
                        )}
                    </Schallschutz>
                </Maincontainer>

                {result !== null ? (
                    <Ergebnisse
                        result={result}
                        korrekturWerte={korrekturWerte}
                        abwasserFallleitungActive={abwasserFallleitungActive}
                        abwasserAnschlussleitungActive={abwasserAnschlussleitungActive}
                    />
                ) : (
                    <>
                        <ResetBlock>
                            Kahjuks teie valikule ei ole hetkel eelvaadet saadaval
                            <ResetBtn onClick={this.resetPage}>
                                <FormattedHTMLMessage id="reset-btn" />
                            </ResetBtn>
                        </ResetBlock>
                    </>
                )}

                <Footer footerData={this.state.footerData} />
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    result: Selectors.getResultValues(state),
    translationsAvalible: Selectors.isTranslationAvalible(state),
    korrekturWerte: Selectors.getKorrekturWerte(state),
    abwasserFallleitung: Selectors.getAbwasserFallleitungChoices(state),
    abwasserAnschlussleitung: Selectors.getAbwasserAnschlussleitungChoices(state),
    abwasserFallleitungActive: state.choices.abwasserFallleitung,
    abwasserAnschlussleitungActive: state.choices.abwasserAnschlussleitung,
    steigstrang: state.choices.trinkwasserSteigstrang,
    anschlussLeitung: state.choices.trinkwasserAnschlussleitung,
    putz: state.choices.putz,
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(MainScreen);

const Wrapper = styled.div`
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
`;

const SelectionComponents = styled(Wrapper)`
    width: 55%;
    ${mediaQ.tablet`
        width: 100%;
    `}
`;

const Maincontainer = styled(Wrapper)`
    display: flex;
    max-width: 1400px;
    ${mediaQ.tablet`
        flex-direction: column;
    `}
`;

const HeaderContainer = styled(Wrapper)`
    max-width: 1400px;
    ${mediaQ.tablet`
        flex-direction: column;
    `}
`;

const HeadingWrapper = styled.div`
    padding-right: 30px;
    padding-left: 30px;
    margin-right: auto;
    margin-left: auto;
    ${mediaQ.tablet`
        padding-right: 0px;
        padding-left: 0px;
    `}
`;

const Header = styled(Wrapper)`
    text-align: left;
    max-width: 1400px;
`;
const HeaderFixed = styled.div`
    text-align: left;
    width: 100%;
    position: fixed;
    background-color: white;
    box-shadow: 0px 5px 5px lightgrey;
    height: 5rem;
    z-index: 12;
    top: 0px;
    left: 0px;
`;
const HeadingLogo = styled.div`
    padding-left: 60px;
    width: 217px;
    height: 100%;
`;

const HeadingLogoWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    margin-top: 2rem;
`;

const HeadingRegion = styled.div`
    font-size: 0.75rem;
    line-height: 1;
    margin-left: 0.3125rem;
    color: #999;
    text-transform: uppercase;
`;

const FooterLogo = styled.div`
    width: 15rem;
    padding-left: 60px;
`;

const FooterRegion = styled.div`
    font-size: 0.75rem;
    line-height: 1;
    margin-left: 0.3125rem;
    color: #999;
    text-transform: uppercase;
`;

const StyledLink = styled.a`
    color: black;
    margin: 0 0 0 1.25rem;
    text-decoration: inherit;
    &:hover {
        text-decoration: underline;
    }
`;
const CopyrightText = styled.span`
    margin: 0 0 0 4rem;
`;

const HeadingText = styled.h1`
    padding-right: 15px;
    padding-left: 15px;
    margin-left: auto;
    margin-right: auto;
    text-transform: uppercase;
`;

const SubHeadingText = styled.p`
    padding-right: 15px;
    padding-left: 15px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 4rem;
    line-height: 1.5rem;
`;

const SchallschutzImgWrapper = styled.div`
    display: inline-block;
    position: relative;
    margin-bottom: 10px;
    width: 100%;
`;

const Schallschutz = styled(Container)`
    height: 100%;
    width: 35%;
    line-height: 1.7rem;
    display: block;
    img {
        height: auto;
        max-width: 100%;
        object-fit: scale-down;
    }
    ${mediaQ.tablet`
        width: 100%;
    `}
`;

const BildbeschreibungHeading = styled.span`
    font-family: GROTESK Bold;
`;
// const Footer = styled.div`
// box-shadow:0px -5px 5px lightgray;
//   padding: 5rem 0 6.25rem;
//  width: 100%;
//     margin-bottom: 140px;
//     padding-left 60px;
//     margin-top:60px;
// `;

const FooterTopRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

const Warning = styled.div`
    background: #ffbbbb;
    border: 1px solid red;
    padding: 1rem;
    font-size: 1rem;
`;
const ResetBtn = styled(ButtonPrimary)`
    margin-left: 16.8px;

    ${mediaQ.tablet`
        margin-left: 0;
        margin-top: 15px;
    `}
`;

const ResetBlock = styled.div`
    padding: 2rem 3rem;
    display: flex;
    -moz-box-align: center;
    align-items: center;
    justify-content: space-between;
    border: 1px solid rgb(204, 204, 204);
    background-color: rgb(244, 244, 244);
    margin: 3rem auto 10px;
    max-width: 1400px;
    color: red;
`;
